import React, { useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { updateDoc, doc } from "firebase/firestore";
import { db } from "../firebaseConfig";
import html2canvas from "html2canvas";
import LoginButtons from "./LoginButtons";

export default function OutputCard({ text, postId, inputText, persona }) {
  const [user, setUser] = useState(null);
  const [showLogin, setShowLogin] = useState(false);
  const [favorited, setFavorited] = useState(false);
  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  const handleFavorite = async () => {
    if (!text || !postId) return;
    if (user) {
      try {
        await updateDoc(doc(db, "posts", postId), { isFavorite: true });
        setFavorited(true);
      } catch (error) {
        console.error("お気に入り登録失敗:", error);
      }
    } else {
      setShowLogin(true);
    }
  };

  const generateImage = async () => {
    const element = document.getElementById("share-image");
    if (!element) return;
    const canvas = await html2canvas(element, {
      scale: window.devicePixelRatio,
      useCORS: true
    });
    const dataUrl = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = dataUrl;
    link.download = "灯りの語り口.png";
    link.click();
  };

  const getPersonaLabel = (key) => {
    const map = {
      benevolent_sage: "慈愛の賢者",
      profound_thinker: "深淵の思想家",
      cheerful_jester: "陽気な道化師",
      zen_master: "禅の老師"
    };
    return map[key] || "語り口不明";
  };

  const shareText = `「${inputText}」→「${text}」 (${getPersonaLabel(persona)})`;
  const encodedText = encodeURIComponent(shareText);
  const twitterUrl = `https://twitter.com/intent/tweet?text=${encodedText}`;
  const lineUrl = `https://social-plugins.line.me/lineit/share?text=${encodedText}`;

  if (!text) return null;

  return (
    <div style={{ marginTop: "20px", padding: "20px", backgroundColor: "#fff8f0", borderRadius: "12px" }}>
      <p style={{ fontWeight: "bold" }}>「{inputText}」</p>
      <p>↓</p>
      <p style={{ fontSize: "1.1em", lineHeight: "1.6" }}>{text}</p>
      <p style={{ fontStyle: "italic", color: "#666" }}>（{getPersonaLabel(persona)}）</p>

      <button
        onClick={handleFavorite}
        style={{
          padding: "8px 12px",
          backgroundColor: favorited ? "#ffd700" : "#ffe4b5",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
          marginBottom: "12px",
          fontWeight: "bold"
        }}
      >
        {favorited ? "お気に入り済み 🌟" : "この灯りをお気に入りに追加"}
      </button>

      {showLogin && (
        <div style={{ marginTop: "16px", background: "#f9f9f9", padding: "16px", borderRadius: "8px" }}>
          <p>お気に入りに追加するにはログインが必要です</p>
          <LoginButtons
            onLogin={(loggedInUser) => {
              setUser(loggedInUser);
              setShowLogin(false);
              handleFavorite();
            }}
          />
        </div>
      )}

      {/* ✅ 共有ボタン */}
      <div style={{ marginTop: "16px", display: "flex", gap: "12px", flexWrap: "wrap" }}>
        <a href={twitterUrl} target="_blank" rel="noopener noreferrer"
          style={{ padding: "8px 12px", backgroundColor: "#1DA1F2", color: "#fff", borderRadius: "6px", textDecoration: "none" }}>
          Xで共有
        </a>
        <a href={lineUrl} target="_blank" rel="noopener noreferrer"
          style={{ padding: "8px 12px", backgroundColor: "#00C300", color: "#fff", borderRadius: "6px", textDecoration: "none" }}>
          LINEで共有
        </a>
        <button onClick={generateImage}
          style={{ padding: "8px 12px", backgroundColor: "#E1306C", color: "#fff", borderRadius: "6px", border: "none" }}>
          Instagram用画像をダウンロード
        </button>
      </div>

      {/* ✅ 非表示の画像化領域 */}
      <div id="share-image" style={{
        width: "600px",
        padding: "24px",
        background: "#fff8f0",
        fontFamily: "serif",
        borderRadius: "12px",
        textAlign: "center",
        position: "absolute",
        left: "-9999px",
        top: "-9999px"
      }}>
        <h2>ことばのゆるしかた</h2>
        <p style={{ fontWeight: "bold" }}>「{inputText}」</p>
        <p>↓</p>
        <p style={{ fontSize: "1.2em" }}>「{text}」</p>
        <p style={{ fontStyle: "italic", color: "#666" }}>（{getPersonaLabel(persona)}）</p>
        <p style={{ fontSize: "0.8em", marginTop: "12px" }}>https://kotobano-yurusikata.web.app/</p>
        <p style={{ fontSize: "0.8em", color: "#888" }}>#ことばのゆるしかた #灯主の語り口 #言葉の供養</p>
      </div>
    </div>
  );
}
